// custom imports
import { httpAgent } from '../../httpAgent';
export const sendInvite = async (userName) => {
    const game = await httpAgent();
    if (userName === localStorage.getItem('userName')) {
        return (false);
    }
    const checkName = await game.checkUserName(userName);
    if (!checkName) {
        return (false);
    }
    const invitation = await game.sendInvite(localStorage.getItem('userName'), userName);
    return (true);
};
export const inviteStatus = async () => {
    const game = await httpAgent();
    const invitation = await game.inviteStatus();
    return invitation[0];
};
export const checkInvite = async () => {
    const game = await httpAgent();
    const invitation = await game.checkInvite();
    //console.log("check")
    //console.log(invitation)
    if (invitation[0] === "") {
        invitation[0] = false;
    }
    if (invitation[0] === localStorage.getItem('userName')) {
        invitation[0] = false;
    }
    return invitation[0];
};
export const acceptInvite = async () => {
    const game = await httpAgent();
    const invitation = await game.acceptInvite();
    //console.log("accept")
    //console.log(invitation)
    return true;
};
export const sendMove = async (arr) => {
    //console.log(arr)
    let temp = [];
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] === null) {
            temp.push("null");
        }
        else {
            temp.push(arr[i]);
        }
    }
    //console.log(temp)
    const game = await httpAgent();
    const move = await game.makeMove(temp);
};
export const sendMovep2 = async (arr) => {
    //console.log(arr)
    let temp = [];
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] === null) {
            temp.push("null");
        }
        else {
            temp.push(arr[i]);
        }
    }
    //console.log(temp)
    const game = await httpAgent();
    const move = await game.makeMovep2(temp);
};
export const getMove = async () => {
    const game = await httpAgent();
    let move = await game.getMove();
    //console.log("move")
    //console.log(move)
    move = move[0];
    if (move[0] === "") {
        return (false);
    }
    let count = 0;
    for (let i = 0; i < move.length; i++) {
        if (move[i] === "null") {
            count = count + 1;
        }
    }
    if (count === 9) {
        return (false);
    }
    let temp = [];
    for (let i = 0; i < move.length; i++) {
        if (move[i] === "null") {
            temp.push(null);
        }
        else {
            temp.push(move[i]);
        }
    }
    return (temp);
};
export const getMovep2 = async () => {
    const game = await httpAgent();
    let move = await game.getMovep2();
    //console.log("move")
    //console.log(move[0])
    move = move[0];
    if (move[0] === "") {
        //console.log("false return")
        return (false);
    }
    let count = 0;
    for (let i = 0; i < move.length; i++) {
        if (move[i] === "null") {
            count = count + 1;
        }
    }
    if (count === 9) {
        return (false);
    }
    let temp = [];
    for (let i = 0; i < move.length; i++) {
        if (move[i] === "null") {
            temp.push(null);
        }
        else {
            temp.push(move[i]);
        }
    }
    return (temp);
};
export const startNewGame = async () => {
    let temp = [];
    for (let i = 0; i < 9; i++) {
        temp.push("null");
    }
    const game = await httpAgent();
    const move = await game.newGame(temp);
};
export const checkNewGame = async () => {
    const game = await httpAgent();
    const move = await game.checkNewGame();
    return (move[0]);
};
export const setSnakeScore = async (score) => {
    const game = await httpAgent();
    const move = await game.setSnakeScore(score);
};
export const getSnakeScore = async () => {
    const game = await httpAgent();
    const move = await game.getSnakeScore();
    return (move);
};
